module.exports = __webpack_public_path__ + "static/basmati-rice-797010c89ee514579c0c271fd4f35e81.jpg";